(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('ProductController', ProductController);

    ProductController.$inject = ['paginationConstants', 'Product', 'ProductType', 'MessageService', '$rootScope', '$state'];

    function ProductController (paginationConstants, Product, ProductType, MessageService, $rootScope, $state) {

        var vm = this;

        // 翻页所需
        vm.page = 1;
        vm.links = null;
        vm.totalItems = null;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        // 製品列表
        vm.productList = [];
        // 查询条件
        vm.searchData = {"id": "", "name": "", "kind": 0};
        vm.defaultSearchData = {"id": "", "name": "", "kind": 0};
        // 商品种类
        vm.productTypeList = [];

        // 初始加载数据
        vm.loadData = loadData;
        // 清空搜索条件
        vm.clear = clear;
        // 点击查询
        vm.search = search;
        // 删除指定商品
        vm.remove = remove;
        // 获取商品种类列表
        vm.loadKindList = loadKindList;

        loadData();
        loadKindList();
        vm.goEdit = goEdit;
        vm.goDel = goDel;

        function loadData() {
            if($rootScope.page != undefined){
                vm.page = $rootScope.page;
                $rootScope.page = undefined;
            }
            if($rootScope.id != undefined){
                vm.searchData.id = $rootScope.id;
                $rootScope.id = undefined;
            }
            if($rootScope.name != undefined){
                vm.searchData.name = $rootScope.name;
                $rootScope.name = undefined;
            }
            if($rootScope.kind != undefined){
                vm.searchData.kind = $rootScope.kind;
                $rootScope.kind = undefined;
            }
            var kind = 0;
            if (vm.searchData.kind != null && vm.searchData.kind != '') {
                kind = vm.searchData.kind;
            }
            Product.query({
                page: vm.page - 1,
                id: vm.searchData.id,
                name: vm.searchData.name,
                kind: kind}, function(result, headers){
                vm.totalItems = headers('X-Total-Count');
                vm.productList = result;
                vm.queryCount = vm.totalItems;
                setTimeout(function() {
                    //屏幕高度
                    var height = document.documentElement.clientHeight;
                    //导航部分的高度
                    var navbarHeight = $("#navbarHeight").height();//20
                    //检索部分的高度
                    var searchHeight = $("#searchHeight").height();//15
                    //表头高度
                    var headerHeight = $("#headerHeight").height();//
                    //分页部分高度
                    var pageHeight = $("#pageHeight").height();
                    //copyRight
                    var copyRight = $("#copyRight").height();
                    var tableDivHeight = height-navbarHeight-19-searchHeight-headerHeight-20-pageHeight-10-copyRight-10-40;
                    $("#tableDiv").css("max-height",tableDivHeight);
                }, 20);
            });

        }

        function remove(id) {
            if(confirm('削除してもよろしいですか?')) {
                Product.delete({id: id}, function(){
                    search();
                    MessageService.success("product.message.deleted");
                    $rootScope.$broadcast('messageChanged');
                });
            }
        }

        function loadKindList() {
            // 获取制品种类列表
            ProductType.list(function(result){
                vm.productTypeList = result;
            });
        }

        function search() {
            vm.page = 1;
            loadData();
        }

        function clear() {
            vm.searchData = angular.copy(vm.defaultSearchData);
            vm.page = 1;
            loadData();
        }

        function goEdit(id) {
            $rootScope.id = vm.searchData.id;
            $rootScope.name = vm.searchData.name;
            $rootScope.kind = vm.searchData.kind;
            $rootScope.page = vm.page;
            $state.go('product.edit', {id: id});
        }

        function goDel(id) {
            $rootScope.id = vm.searchData.id;
            $rootScope.name = vm.searchData.name;
            $rootScope.kind = vm.searchData.kind;
            $rootScope.page = vm.page;
            $state.go('product.delete', {id: id});
        }
    }
})();
